// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Zr-z","heading":"_r-z"};